export default __webpack_public_path__ + "static/media/flipkart.f0af2d24.svg";